import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { Subproces } from '../types/Subproces'

export { updateSubprocesForEntity }

const updateSubprocesForEntity = async ({
  entity: { id, type },
  subprocesInfo,
}: {
  entity: Entity
  subprocesInfo: Partial<Subproces & { text: string }>
}): Promise<Subproces> => {
  const { _id, ...rest } = subprocesInfo

  const { data } = await apiClient({
    url: `/rest/${type}/${id}/subproces/${_id}`,
    method: 'PATCH',
    data: rest,
  })

  return data
}
